import { render, staticRenderFns } from "./ViewReportsTotalPadrillo.vue?vue&type=template&id=5884fee8&scoped=true"
import script from "./ViewReportsTotalPadrillo.vue?vue&type=script&lang=js"
export * from "./ViewReportsTotalPadrillo.vue?vue&type=script&lang=js"
import style0 from "./ViewReportsTotalPadrillo.vue?vue&type=style&index=0&id=5884fee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5884fee8",
  null
  
)

export default component.exports